import * as type from '../mutation-types'

const state = {
  collection: [],
  counselor: {}
}

const actions = {
  [type.GET_COUNSELORS]({ commit }, options = {}) {
    return axios
      .get('/api/counselor/list', options)
      .then(res => {
        commit(type.GET_COUNSELORS, res.data)
      })
      .catch(error => {
        throw new Error(error)
      })
  },
  [type.GET_COUNSELOR]({ commit }, id) {
    return axios
      .get(`/api/counselor/${id}`)
      .then(
        res => {
          commit(type.GET_COUNSELOR, res.data)
        },
        error => {
          throw new Error(error)
        }
      )
  },
  [type.RESET_COUNSELORS]({ commit }) {
    commit(type.RESET_COUNSELORS)
  },
  [type.RESET_COUNSELOR]({ commit }) {
    commit(type.RESET_COUNSELOR)
  }
}

const mutations = {
  [type.GET_COUNSELORS](_state, collection) {
    Object.assign(_state, { collection })
  },
  [type.GET_COUNSELOR](_state, counselor) {
    Object.assign(_state, { counselor })
  },
  [type.RESET_COUNSELORS](_state) {
    Object.assign(_state, { counselors: {} })
  },
  [type.RESET_COUNSELOR](_state) {
    Object.assign(_state, { counselor: {} })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/counselors.js